import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'groupBySection', standalone: true })
export class GroupBySectionPipe implements PipeTransform {
  transform(actions: any[]): { name: string, actions: any[] }[] {
    if (!actions) return []
    const groups: { [key: string]: any[] } = {}
    actions.forEach(action => {
      if (!groups[action.section]) {
        groups[action.section] = []
      }
      groups[action.section].push(action)
    })
    return Object.keys(groups).map(name => ({ name, actions: groups[name] }))
  }
} 